module.exports = __webpack_public_path__ + "img/get-your-guide-logo.bf64cf5.png";